import React, { useEffect, useState } from 'react'
import { withRouter, useHistory, useParams } from 'react-router-dom'
import { onSubmitText } from '../../constantes/onSubmitText'
import { routes } from '../../constantes/routes'
import CloseBtn from '../buttons/CloseBtn'
import { swalAlertIsConfirm, swalAlertError, swalSuccessGeneral } from '../../utils/swalAlert'
import { swalTitle } from '../../constantes/swalTitle'
import ResetPasswordForm from './ResetPasswordForm'
import { usersApi } from '../../api/usersApi'
import { authApi } from '../../api/authApi'

const ChangePasswordProfile = () => {
    let { id } = useParams()
    const history = useHistory()
    
    const [inputs, setinputs] = useState({
        nombre: '',
        email: '',
        telefono: '',
        passwordOld: '', 
        passwordNew: '', 
        repeatPassword: '' ,
        roles: {
            nombre: '',
        },
        tipoZonas: {
            nombre: '',
        },
        id_TipoColor: ''
    })

    const [isDisable, setIsDisable] = useState(false)

    const toMyProfile = () => {
        history.push(routes.PROFILE + id)
    }

    const toMain = () => {
        history.push(routes.MAIN)
    }

    useEffect(() => {
        getInfoUser(id)
    }, [id])

    const getInfoUser = async (idUser) => {
        try {
            const response = await usersApi.getUserById(idUser)
            Object.keys(inputs).map(input => setinputs(inputs => ({ ...inputs, [input]: response.data[input] })))
        } catch (error) {
            toMain()
        }
    }

    const handleChange = (event) => {
        const value = event.target.value
        const name = event.target.name
        setinputs(inputs => ({ ...inputs, [name]: value }))
    }

    const handleSubmit = async (event) => {
        event.preventDefault()
        setIsDisable(true)
        try {
            const alert = await swalAlertIsConfirm('¿Seguro que quieres guardar los cambios?')
            let validations = await validatePassword()
            if (validations.isError) {
                swalAlertError(validations.message)
                setIsDisable(false)
            } 
            if(alert.isConfirmed){
                let response = await usersApi.updateUserProfile(inputs)
                swalSuccessGeneral(swalTitle.Actualizado, "Se ha actualizado correctamente",response)
                toMyProfile()
            }
        } catch (error) {
            //------- HAY QUE FIJAR ESTE ERROR, ENTRA EN EL CATCH, NO ESPERA EL AWAIT Y RESPONSE LLEGA UNDEFINED
            swalAlertError(error.response.data || error.response.statusText)
            setIsDisable(false)
            toMyProfile()
        }
    }

    const validateForm = () => {
        return  inputs.password !== ''
        && inputs.passwordNew !== ''
        && inputs.repeatPassword !== ''
        && (inputs.passwordNew === inputs.repeatPassword)
    }

    const validatePassword = async () => {
        let isError = false
        let message = ""
        if (inputs.passwordOld !== '' && inputs.passwordOld !== undefined) {
            let response = await authApi.login({ Email: inputs.email, Password: inputs.passwordOld })
            if (response.status == "" || response.data == null) {
                message = "Contraseña actual incorrecta."
                isError = true
            }
            if (inputs.passwordNew !== inputs.repeatPassword) {
                message += " Los campos nueva contraseña y repetir contraseña no coinciden."
                isError = true
            }
        } else if (inputs.passwordNew !== '' && inputs.passwordNew !== undefined) {
            message = "Introduce tu contraseña actual para poder cambiarla."
            isError = true
        }
        return { isError, message }
    }

    return (
        <div className="products">
            <div className="products__title__container mb-30">
                <h3 className="products__title">Cambiar contraseña</h3>
                <button className="close-btn" onClick={toMyProfile}>
                    <CloseBtn />
                </button>
            </div>
            <ResetPasswordForm
                inputs={inputs}
                handleChange={handleChange}
                isDisable={isDisable || !validateForm()}
                textBtn={onSubmitText.Guardar}
                handleSubmit={handleSubmit}
            />
        </div>
    )
}
export default withRouter(ChangePasswordProfile)